<h1>핵심기술</h1>

<div class="technology">
    <div id="ai" [ngClass]="{'sticky': aiStickyFlag}">
        <div class="sticky-position">
            <h1 id="top">
                • AI<i class="xi-angle-down-min" ></i>
            </h1>
            <div class="title" >
                <select (change)="scrollMoveToView($event)">
                    <option [value]="'ai01'">AI</option>
                    <option [value]="'ro01'">Robotics</option>
                    <option [value]="'vi01'">Vision</option>
                </select>
            </div>
            <div class="list" >
                <select id="aiContents"
                    (change)="scrollMoveToView($event)">
                    <option [value]="'ai01'">1. 사물인식 학습데이터 생성기술</option>
                    <option [value]="'ai02'">2. 실시간 당구공, 큐대 인식</option>
                    <option [value]="'ai03'">3. 자율 주행용 사물 인식</option>
                    <option [value]="'ai04'">4. 실시간 팜터치(Palm Touch) 인식</option>
                    <option [value]="'ai05'">5. 피킹 로봇용 3D 사물 인식</option>
                </select>
            </div>
        </div>
        <div id="ai01">
            <img src="/assets/images/AI01.png" (load)="afterLoad()">
            <h2>1. 사물인식 학습데이터 생성기술</h2>
            <em> • HTML5 Canvas 기반의 웹이미지 가공 툴 <br> • 주행 영상과 자율주행용 센서
                데이터(GPS, CAN, AVM, Camera, LiDAR, RADAR, Ultrasonic) 파싱 및 동기화 <br>
                • 라벨링 정보 다양한 포펫으로의 Impart/Export 기능
            </em>
        </div>
        <div id="ai02">
            <img src="/assets/images/AI02.png" (load)="afterLoad()"> 
            <h2>2. 실시간 당구공, 큐대 인식</h2>
            <em> •공, 큐대 인식을 인식을 위한 학습데이터 라벨링/학습 <br> • 조도, 그림자, 영상
                번짐(Blur) 등의 다양한 환경에 대한 인공지능 인식<br> • 실시간 인식을 위한
                Thread/CPU/GPU Utilization 최적화 기술
            </em>
        </div>
        <div id="ai03">
            <img src="/assets/images/AI03.png" (load)="afterLoad()">
            <h2>3. 자율 주행용 사물 인식</h2>
            <em> • 인공지능을 이용한 자동차, 이륜차, 자전거, 보행자, 동물 자동 라벨링 <br> • 사물
                자동 Tacking 기술 <br> • 사물 형태를 Segmentation 하는 기술 <br> •
                2D 영상에 3D Point Cloud Overlay 기술과 사물인식 기술을 혼용한 사물 거리 자동 측정 <br>

            </em>
        </div>
        <div id="ai04">
            <img src="/assets/images/AI04.png" (load)="afterLoad()">
            <h2>4. 실시간 팜터치(Palm Touch) 인식</h2>
            <em> •빔프로젝트 영상의 UI/UX Button 기능을 위한 손바닥 터치(Palm Touch) 인공지능 인식 <br>
            •다양한 형태(피부색, 크기, 모양 등)와 장갑착용 손애 대한 학습데이터 라벨링/학습  <br>
            

            </em>
        </div>
        <div id="ai05">
            <img src="/assets/images/AI05.png"  (load)="afterLoad()">
            <h2>5. 피킹 로봇용 3D 사물 인식</h2>
            <em> • 다양한 형태의 포장사물에 대한 학습데이터 라벨링/학습 <br>
            • 포장사물별 그래스프 플랜닝 방법 라벨링/학습<br> 

            </em>
        </div>
    </div>
    <div id="robotics" [ngClass]="{'sticky': roSitckyFlag}">
        <div class="sticky-position">
            <h1>
                • Robotics<i class="xi-angle-down-min"></i>
            </h1>
            <div class="title" >
                <select (change)="scrollMoveToView($event)">
                    <option [value]="'ai01'">AI</option>
                    <option [value]="'ro01'" selected>Robotics</option>
                    <option [value]="'vi01'">Vision</option>

                </select>
            </div>
            <div class="list" >
                <select id="roboContents"
                (change)="scrollMoveToView($event)" >
                    <option [value]="'ro01'">1. 피킹 로봇용 다양한 사물에 대한 그래스프
                        플랜닝(Grasp Planning)</option>
                    <option [value]="'ro02'">2. 물류 자동화 로봇 시스템 최적화 디스패치
                        플랜닝(Dispatch Planning)</option>

                </select>
            </div>
        </div>
        <div id="ro00" >
            <img src="/assets/images/RO00.png" (load)="afterLoad()">
            <h2>1. AR당구시스템을 위한 보조 로봇 시스템</h2>
            <em> • AR 당구시스템 게임 Player 역할<br> 
            • AR 당구시스템 게임 심판 역할<br> 
            • 큐 장애 시 Bridge 역할
            </em>
        </div>
        <div id="ro01">
            <img src="/assets/images/RO01.png" (load)="afterLoad()">
            <h2>2. 피킹 로봇용 다양한 사물에 대한 그래스프 플랜닝(Grasp Planning)</h2>
            <em> •포장사물인식, 거리측정, 그래스프 플랜닝 자동 선택을 통한 포장사물 피킹 알고리즘 <br> 
            </em>
        </div>
        <div id="ro02">
            <img src="/assets/images/RO02.png" (load)="afterLoad()">
            <h2>3. 물류 자동화 로봇 시스템 최적화 디스패치 플랜닝(Dispatch Planning)</h2>
            <em> • 물류 자동화를 위한 Delivery, Docking, Searching, Picking, Assorting 제어 자동화 최적화 <br>
            </em>
        </div>
    </div>
    <div id="vision" [ngClass]="{'sticky': viStickyFlag}">
        <div class="sticky-position">
            <h1>
                • Vision<i class="xi-angle-down-min"></i>
            </h1>
            <div class="title" >
                <select (change)="scrollMoveToView($event)">
                    <option [value]="'ai01'">AI</option>
                    <option [value]="'ro01'">Robotics</option>
                    <option [value]="'vi01'" selected>Vision</option>

                </select>
            </div>
            <div class="list" >
                <select id="visionContents"
                (change)="scrollMoveToView($event)">
                    <option [value]="'vi01'">1. 카메라와 빔프로젝트 이미지 원점 조정을 위한
                        켈리브레이션(Calibration)</option>
                    <option [value]="'vi02'">2. 자율 주행용 2D 영상에 3D Point Cloud
                        오버레이(Overlay)기술</option>
                    <option [value]="'vi03'">3. 자율 주행용 사물 추적과 시맨틱
                        세그멘테이션(Semantic Segmentation)</option>
                    <option [value]="'vi04'">4. 3D Point Cloud 영상 모델링과 라벨링 기술</option>
                    <option [value]="'vi05'">5. 실시간 당구공, 큐대의 정밀 좌표 인식</option>
                </select>
            </div>
        </div>
        <div id="vi01" >
            <img src="/assets/images/VI01.png" (load)="afterLoad()">
            <h2>1. 카메라와 빔프로젝트 이미지 원점 조정을 위한 켈리브레이션(Calibration)</h2>
            <em> • 1mm 오차수준의 Camera World/Real World 좌표 Calibration 알고리즘 <br> 
            • 1mm 오차수준의 Beam Projection/Camera World/Real World Calibration 알고리즘 <br> 
            • 자동화된 Camera/Beam Project Intrinsic, Extrinsic, Remap Matrix 추출 프로그램
            </em>
        </div>
        <div id="vi02">
            <img src="/assets/images/VI02.png" (load)="afterLoad()">
            <h2>2. 자율 주행용 2D 영상에 3D Point Cloud 오버레이(Overlay)기술</h2>
            <em> • 3D Cloud Point Calibration 기술 <br>
            </em>
        </div>
        <div id="vi03">
            <img src="/assets/images/VI03.png" (load)="afterLoad()">
            <h2>3. 자율 주행용 사물 추적과 시맨틱 세그멘테이션(Semantic Segmentation)</h2>
            <em> • Object Tracking 알고리즘을 이용한 사물 추적 기술<br> 
            • Contour 알고리즘을 이용한 사물 시맨틱 형상 분리 기술 <br> 
            </em>
        </div>
        <div id="vi04">
            <img src="/assets/images/VI04.png" (load)="afterLoad()"> 
            <h2>4. 3D Point Cloud 영상 모델링과 라벨링 기술</h2>
            <em> • 웹 3D Viewer를 이용한 3D Cloud Point 뷰와 라벨링 기술  <br>      
            </em>
        </div>
        <div id="vi05">
            <img src="/assets/images/VI05.png" (load)="afterLoad()">
            <h2>5. 실시간 당구공, 큐대의 정밀 좌표 인식</h2>
            <em> •당구공 정밀좌표를 위한, Circle, Ellipse, Contour 찾기 및 가운데 중심점 찾기 알고리즘 <br>
            • 큐대 시작부분(Tip)을 찾기 위한 영상인식 알고리즘 <br> 
            • 큐대 시작부분을 향하는 방향을 찾기 위한 알고리즘 <br>
            • 4K/30fps 실시간 영상처리를 위한 CPU/GPU Utilization 최적화 알고리즘
            </em>
        </div>
    </div>


</div>